module.exports = __webpack_public_path__ + "static/media/expandVector.840f727a.svg";